<template>
  <v-dialog v-model="dialog" :fullscreen="$vuetify.display.smAndDown" persistent>
    <v-card>
      <!-----------------------------------------TITLE BAR----------------------------------------->
      <v-card-title class="redColor d-flex">
        <!--TITLE-->
        <span class="headline text-white">
          {{ $t("parts.inventory.form.edit_part") }}
          {{ editId }}
        </span>

        <v-spacer />

        <!--CLOSE BUTTON-->
        <v-btn variant="outlined" icon large color="white" @click="close">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <!-------------------------------------------FORM-------------------------------------------->
      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <div class="container">
          
            <v-row>
              <!-------------------------------------SHIPMENT-------------------------------------->
              <v-col cols="12" sm="6" lg="6">
                <v-select
                  v-model="part.shipment_id"
                  :items="shipments"
                  :label="$t('parts.inventory.form.shipment')"
                  color="red-darken-1"
                  solo
                  item-title="name"
                  item-value="_id"
                  disabled
                />
              </v-col>
              <!------------------------EXTERNAL COLOR------------------------------------->
              <v-col cols="12" sm="3" lg="3">
                <v-text-field
                  v-model="externalColor"
                  :label="$t('vehicle_entry.info.external_color')"
                  variant="outlined"
                  disabled
                />
              </v-col>
              <!-------------------------------------EBAY CODE------------------------------------->
              <v-col cols="12" sm="3" lg="3">
                <v-text-field
                  v-model.trim="part.ebayCode"
                  :label="$t('parts.inventory.form.ebay_code')"
                  color="red-darken-1"
                  variant="outlined"
                />
              </v-col>
              <!---------------------------------------NOTES--------------------------------------->
              <v-col cols="12" sm="4" lg="4">
                <v-text-field
                  v-model="part.notes"
                  :label="$t('parts.inventory.form.notes')"
                  color="red-darken-1"
                  variant="outlined"
                  hide-details
                />
                <span
                  class="col-12 d-flex justify-end text-end ml-auto"
                  style="color: grey"
                  >{{
                    part.notes
                      ? "(" + part.notes.length + $t("characters") + ")"
                      : ""
                  }}</span
                >
              </v-col>
              <!----------------------------------------PRA---------------------------------------->
              <v-col cols="12" sm="4" lg="4">
                <v-text-field
                  v-model="part.pra"
                  :label="$t('parts.inventory.form.pra')"
                  color="red-darken-1"
                  variant="outlined"
                />
              </v-col>
              <!---------------------------------------BRAND--------------------------------------->
              <v-col cols="12" sm="4" lg="4">
                <v-text-field
                  v-model="part.brand"
                  :label="$t('parts.inventory.form.brand')"
                  color="red-darken-1"
                  variant="outlined"
                />
              </v-col>

              <v-col
                v-if="
                  Array.isArray(positionAlerts) &&
                  positionAlerts.length > 0
                "
                class="mt-0 pt-0"
                cols="12"
                sm="12"
                lg="12"
              >
                <div>
                  <v-icon
                    :color="getAlertColor(positionAlerts[0].type || 'info')"
                    size="18"
                    class="ml-1 cursor-pointer"
                  >
                    {{ getAlertIcon(positionAlerts[0].type || "info") }}
                  </v-icon>

                  <span>{{ $t(positionAlerts[0].reason) || "" }}</span>
                </div>
              </v-col>

              <!------------------------------------REPOSITORY------------------------------------->
              <v-col cols="7" lg="4">
                <v-select
                  v-model="repository"
                  :items="repositories"
                  :label="$t('parts.inventory.form.select_repository')"
                  color="red-darken-1"
                  variant="outlined"
                  item-title="name"
                  return-object
                />
              </v-col>
              <!---------------------------------------ROOM---------------------------------------->
              <v-col cols="5" lg="3">
                <v-select
                  v-model="room"
                  :items="repository && repository.rooms ? repository.rooms : []"
                  :label="$t('parts.inventory.form.select_room')"
                  color="red-darken-1"
                  variant="outlined"
                  item-title="name"
                  return-object
                />
              </v-col>
              <!-------------------------------------LOCATION-------------------------------------->
              <v-col cols="6" lg="3">
                <v-select
                  v-model="location"
                  :items="room && room.locations ? room.locations : []"
                  :label="$t('parts.inventory.form.select_location')"
                  color="red-darken-1"
                  variant="outlined"
                  item-title="code"
                  return-object
                />
              </v-col>
              <!------------------------------------POSITION X------------------------------------->
              <v-col cols="3" lg="1">
                <v-select
                  v-model="position_x"
                  :items="pos_x"
                  :label="$t('parts.inventory.form.select_x')"
                  color="red-darken-1"
                  variant="outlined"
                />
              </v-col>
              <!------------------------------------POSITION Y------------------------------------->
              <v-col cols="3" lg="1">
                <v-select
                  v-model="position_y"
                  :items="pos_y"
                  :label="$t('parts.inventory.form.select_y')"
                  color="red-darken-1"
                  variant="outlined"
                />
              </v-col>
              <!-------------------- QUALITY / CONDITION / EXPORT (mobile-friendly group) ------>
              <v-col cols="12" class="pa-0 ma-0">
                <v-row dense class="edit-dialog-part-meta">
              <v-col
                cols="12"
                sm="6"
                md="3"
                lg="3"
                class="edit-dialog-quality-col"
              >
                <div class="subheading mb-1">
                  {{ $t("parts.inventory.form.quality") }}
                </div>
                <div class="d-flex align-center flex-wrap gap-2">
                  <v-rating
                    :model-value="selectedQualityRating"
                    length="5"
                    color="yellow-darken-2"
                    active-color="yellow"
                    empty-icon="mdi-star-outline"
                    full-icon="mdi-star"
                    :size="qualityRatingSize"
                    class="edit-dialog-quality-rating"
                    @update:model-value="onEditQualitySelect"
                  />
                  <v-btn
                    v-if="selectedQualityRating > 0"
                    icon
                    variant="text"
                    size="small"
                    color="grey"
                    @click="onEditQualitySelect(0)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div class="text-caption text-grey mt-1">
                  <span v-if="selectedQualityRating > 0">
                    {{ selectedQualityRating }} {{ selectedQualityRating === 1 ? 'star' : 'stars' }}
                  </span>
                  <span v-else>{{ $t('parts.advanced_search.select_quality') }}</span>
                </div>
              </v-col>
               <v-col
                v-if="partEcoScore"
                cols="12"
                sm="6"
                md="5"
                lg="5"
                class="edit-dialog-eco-col"
              >
                <eco-score-badge
                  :score="partEcoScore.score"
                  :second-hand-kg="partEcoScore.secondHandCO2"
                  :new-kg="partEcoScore.newCO2"
                />
              </v-col>
              <!--------------------------------------CONDITION--------------------------------------->
              <v-col
                cols="12"
                sm="6"
                md="2"
                lg="2"
                class="part-export-col edit-dialog-condition-col"
              >
                <div class="part-export-field">
                  <div class="part-export-field__header">
                    {{ $t("parts.inventory.form.condition") }}
                  </div>
                  <v-checkbox
                    v-model="part.isNewPart"
                    :label="$t('parts.inventory.form.new')"
                    color="red-darken-3"
                    hide-details
                    density="compact"
                    class="part-export-field__checkbox"
                  />
                </div>
              </v-col>
              <!--------------------------------------EXPORT EBAY / RR--------------------------------------->
              <export-marketplaces
                v-model:export-ebay="part.exportEbay"
                v-model:rr-export="part.rrExport"
                :part-institution-rr="!!part.institution_id?.rr"
                :cols="exportMarketplaceColSize"
                sm="6"
                md="2"
                lg="2"
              />
                </v-row>
              </v-col>
              <!---------------------------------------PRICE--------------------------------------->
              <!--PRICE-->
              <v-col
                cols="6"
                sm="4"
                :md="
                  $store.getters.institutionDisplayFeatures.partWeight ? 2 : 0
                "
              >
                <v-text-field
                  :model-value="part.price"
                  :disabled="
                    $store.getters.role === 'User' ||
                    $store.getters.role === 'EbayOperator'
                  "
                  :label="$t('parts.inventory.form.price')"
                  variant="outlined"
                  color="red-darken-1"
                  type="number"
                  step="0.01"
                  min="0"
                  max="10000"
                  :data-ok="part.price"
                  oninput="if(this.value!==''&&Number(this.value)>10000){this.value=this.getAttribute('data-ok')??'';}else if(!this.validity.valid){this.value=this.getAttribute('data-ok')??'';}else{this.setAttribute('data-ok',this.value);}"
                  @update:model-value="part.price = keepPriceIfValid($event, part.price)"
                />
              </v-col>
              <!--COST-->
              <v-col
                cols="6"
                sm="4"
                :md="
                  $store.getters.institutionDisplayFeatures.partWeight ? 2 : 0
                "
              >
                <v-text-field
                  v-model="part.cost"
                  :disabled="
                    $store.getters.role === 'User' ||
                    $store.getters.role === 'EbayOperator'
                  "
                  :label="$t('parts.inventory.form.cost')"
                  color="red-darken-1"
                  variant="outlined"
                  type="number"
                  step="0.01"
                  min="0"
                  oninput="validity.valid||(value='');"
                />
              </v-col>
              <!--INFOCAR REFERENCE PRICE-->
              <v-col
                cols="6"
                sm="4"
                :md="
                  $store.getters.institutionDisplayFeatures.partWeight ? 2 : 0
                "
              >
                <v-text-field
                  v-if="part.infoCar && part.infoCar.price"
                  v-model="part.infoCar.price"
                  :label="$t('parts.inventory.form.reference_price')"
                  color="red-darken-1"
                  variant="outlined"
                  disabled
                />
                <v-text-field
                  v-else
                  :label="$t('parts.inventory.form.reference_price')"
                  color="red-darken-1"
                  variant="outlined"
                  disabled
                />
              </v-col>
             
              <!--CURRENCY-->
              <v-col
                cols="12"
                sm="4"
                :md="
                  $store.getters.institutionDisplayFeatures.partWeight ? 2 : 0
                "
              >
                <v-select
                  v-model="part.currency"
                  :disabled="
                    $store.getters.role === 'User' ||
                    $store.getters.role === 'EbayOperator'
                  "
                  :items="currency"
                  :label="$t('parts.inventory.form.currency')"
                  color="red-darken-1"
                  variant="outlined"
                />
              </v-col>
              <!--------------------------------------WEIGHT--------------------------------------->
              <v-col
                v-if="$store.getters.institutionDisplayFeatures.partWeight"
                cols="8"
                md="2"
              >
                <v-text-field
                  v-model="weight.value"
                  :label="$t('parts.inventory.form.weight')"
                  color="red-darken-1"
                  variant="outlined"
                  type="number"
                  step="0.01"
                  min="0"
                  oninput="validity.valid||(value='');"
                />
              </v-col>
              <v-col
                v-if="$store.getters.institutionDisplayFeatures.partWeight"
                cols="4"
                md="2"
              >
                <v-select
                  v-model="weight.unit"
                  :items="weightUnits"
                  :label="$t('parts.inventory.form.unit')"
                  color="red-darken-1"
                  variant="outlined"
                />
              </v-col>
              <!-------------------------------------WARRANTY-------------------------------------->
              <v-col cols="12" sm="4">
                <v-select
                  v-model="part.warranty_id"
                  :disabled="
                    $store.getters.role === 'User' ||
                    $store.getters.role === 'EbayOperator'
                  "
                  :items="warranties"
                  :label="$t('parts.inventory.form.warranty')"
                  color="red-darken-1"
                  variant="outlined"
                  :item-title="() => ''"
                  item-value="_id"
                >
                  <!-- Dropdown items -->
                  <template #item="{ props: itemProps, item }">
                    <v-list-item v-bind="itemProps">
                      {{ (item.raw.return_days ?? 0) / 86400 }}
                      {{ $t("warranties.days") }}
                    </v-list-item>
                  </template>

                  <!-- Selected value -->
                  <template #selection="{ item }">
                    <span v-if="item">
                      <!-- Find the selected warranty object -->
                      {{ (item.raw.return_days ?? 0) / 86400 }}
                      {{ $t("warranties.days") }}
                    </span>
                    <span v-else>
                      {{ $t("parts.inventory.form.warranty") }}
                    </span>
                  </template>
                </v-select>
              </v-col>
              <!---------------------------------MANUFACTURER CODE--------------------------------->
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="part.manufacturer_code"
                  :label="$t('parts.inventory.form.manufacturer_code')"
                  color="red-darken-1"
                  variant="outlined"
                />
              </v-col>
              <!---------------------------------REPLACEMENT CODES--------------------------------->
              <v-col cols="12" sm="4">
                <v-text-field
                  v-if="part.infoCar && part.infoCar.replacementCodes"
                  v-model="part.infoCar.replacementCodes"
                  :label="$t('parts.inventory.form.replacement_codes')"
                  color="red-darken-1"
                  variant="outlined"
                  disabled
                />
                <v-text-field
                  v-else
                  :label="$t('parts.inventory.form.replacement_codes')"
                  color="red-darken-1"
                  variant="outlined"
                  disabled
                />
              </v-col>
              <!--------------------------------INSERTED OEM CODES--------------------------------->
              <!-- <v-col
                v-if="part.oemCodes && part.oemCodes.length > 0"
                cols="12"
                sm="6"
              >
                <div class="caption grey--text text--darken-1">
                  {{ $t("parts.insert_parts.form.oem_codes") }}
                </div>
                <v-chip v-for="(item, index) in part.oemCodes" :key="index">
                  {{ item }}
                  <v-icon right @click="removeOemCode(index)">
                    mdi-minus-circle-outline
                  </v-icon>
                </v-chip>
              </v-col> -->
              <v-col
                v-if="
                  $store.getters.institutionExportGoogleLeko ||
                  $store.getters.institutionExportEbayLeko
                "
                cols="12"
                md="12"
                class="mt-0 pt-0"
              >
                <h3>{{ $t("parts.inventory.form.shipping_costs") }}</h3>
              </v-col>
              <v-col
                v-if="$store.getters.institutionExportEbayLeko"
                cols="12"
                md="6"
              >
                <h3 class="mb-2">Ebay</h3>
                <div class="d-flex flex-wrap shipping-cost-fields">
                  <v-text-field
                    v-for="(value, country) in shippingCosts.ebay"
                    :key="'ebay-' + country"
                    v-model="shippingCosts.ebay[country]"
                    :label="`${country.toUpperCase()}`"
                    type="number"
                    variant="outlined"
                    hide-details
                    class="shipping-cost-field"
                  />
                </div>
              </v-col>
              <v-col
                v-if="$store.getters.institutionExportGoogleLeko"
                cols="12"
                md="3"
              >
                <h3 class="mb-2">Google</h3>
                <div class="d-flex flex-wrap shipping-cost-fields">
                  <v-text-field
                    v-for="(value, country) in shippingCosts.google"
                    :key="'google-' + country"
                    v-model="shippingCosts.google[country]"
                    :label="`${country.toUpperCase()}`"
                    type="number"
                    variant="outlined"
                    hide-details
                    class="shipping-cost-field"
                  />
                </div>
              </v-col>
              <v-col
                v-if="
                  ($store.getters.role == 'InstitutionAdmin' &&
                    $store.getters.rr_member == true) ||
                  $store.getters.role == 'LekoAdmin' ||
                  $store.getters.role == 'SuperAdmin'
                "
                cols="12"
                sm="6"
                md="3"
              >
                <h3 class="mb-2">ReteRicambi</h3>
                <v-text-field
                  v-model="shippingCosts.rr"
                  label="RR"
                  type="number"
                  variant="outlined"
                  hide-details
                  class="shipping-cost-field"
                />
              </v-col>
              <v-col
                v-if="
                  $store.getters.institutionExportEbayLeko &&
                  allowedWeightRanges.length > 0
                "
                cols="12"
                sm="6"
                md="3"
              >
               <h3 class="mb-2">{{$t('parts.inventory.form.weight_range')}}</h3>
                <v-select
                  v-model="part.weightRange"
                  :items="weightRanges"
                  :label="$t('parts.inventory.form.weight_range')"
                  :loading="loadingWeightRanges"
                  color="red-darken-1"
                  variant="outlined"
                  item-title="label"
                  item-value="value"
                  
                />
              </v-col>

              <!--------------------------------------BUTTONS-------------------------------------->
              <v-col cols="12">
                <v-row align="center" justify="center" class="edit-dialog-actions-row">
                  <!-- change part position - to be deployed soon -->
                  <v-btn
                    v-if="canChangePosition"
                    variant="outlined"
                    color="primary"
                    class="mx-1 edit-dialog-action-btn"
                    @click="changePosition = !changePosition"
                  >
                    {{ $t("parts.inventory.form.change_position") }}
                  </v-btn>
                  <v-btn
                    v-if="!changePhoto"
                    variant="outlined"
                    color="primary"
                    class="mx-1 edit-dialog-action-btn"
                    @click="changePhoto = true"
                  >
                    {{ $t("parts.inventory.form.change_photo") }}
                  </v-btn>
                  <v-tooltip
                    v-if="
                      role === 'LekoAdmin' ||
                      role === 'LekoEmployee' ||
                      role === 'SuperAdmin'
                    "
                    location="top"
                  >
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        variant="outlined"
                        color="primary"
                        class="mx-1 edit-dialog-action-btn"
                        @click="openIdChanger"
                      >
                        {{ $t("parts.inventory.form.change_id") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("parts.inventory.form.change_id_hint") }}</span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="
                      role === 'LekoAdmin' ||
                      role === 'LekoEmployee' ||
                      role === 'SuperAdmin'
                    "
                    location="top"
                  >
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        variant="outlined"
                        color="primary"
                        class="mx-1 edit-dialog-action-btn"
                        @click="openIdSwitcher"
                      >
                        {{ $t("parts.inventory.form.switch_id") }}
                      </v-btn>
                    </template>
                    <span>{{ $t("parts.inventory.form.switch_id_hint") }}</span>
                  </v-tooltip>
                  <v-btn
                    v-if="
                      role === 'LekoAdmin' ||
                      role === 'LekoEmployee' ||
                      role === 'SuperAdmin'
                    "
                    variant="outlined"
                    color="primary"
                    class="mx-1 edit-dialog-action-btn"
                    @click="changeInfoCarCode = !changeInfoCarCode"
                  >
                    {{ $t("parts.inventory.form.change_info_car_code") }}
                  </v-btn>
                  <v-btn
                    v-if="canSetCustomTitle"
                    variant="outlined"
                    color="primary"
                    class="mx-1 edit-dialog-action-btn"
                    :disabled="!!part.infoCar && !!part.infoCar._id"
                    @click="setCustomTitle = !setCustomTitle"
                  >
                    {{ $t("parts.inventory.form.set_custom_title") }}
                  </v-btn>
                </v-row>
              </v-col>
              <!-----------------------------------INFOCAR CODE------------------------------------>
              <v-col v-if="changeInfoCarCode === true" cols="12">
                <v-text-field
                  v-model.trim="infoCarCode"
                  :color="validInfoCarCode ? 'success' : 'error'"
                  :append-icon="
                    validInfoCarCode ? 'mdi-check-circle' : 'mdi-alert'
                  "
                  :label="$t('parts.inventory.form.info_car_code')"
                  :loading="loadingInfoCar"
                  @keyup.enter="searchCode()"
                  @click:append="searchCode()"
                />
                <v-select
                  v-model="newInfoCarCode"
                  :items="infoCarCodes"
                  item-value="_id"
                  :filter="() => true"
                  :item-title="`description.descriptionId.title.${$store.getters.language}`"
                  :label="
                    $t('leko_employees.approve_parts.form.info_car_result')
                  "
                  color="red-darken-1"
                  return-object
                >
                  <template #item="{ props, item }">
                    <v-list-item v-bind="props">
                      <v-list-item-title>
                        {{ item.raw.oemCode }} -
                        {{
                          item.raw.description &&
                          item.raw.description.descriptionId
                            ? item.raw.description.descriptionId.category.it
                            : ""
                        }}
                        :
                        {{
                          item.raw.description &&
                          item.raw.description.descriptionId
                            ? item.raw.description.descriptionId.title.it
                            : ""
                        }}
                        -
                        {{
                          item.raw.description
                            ? getPosition(item.raw.description.positionCode)
                            : ""
                        }}
                      </v-list-item-title>
                    </v-list-item>
                  </template>

                  <template #selection="{ item }">
                    {{ item.raw.oemCode }} -
                    {{
                      item.raw.description && item.raw.description.descriptionId
                        ? item.raw.description.descriptionId.category.it
                        : ""
                    }}
                    :
                    {{
                      item.raw.description && item.raw.description.descriptionId
                        ? item.raw.description.descriptionId.title.it
                        : ""
                    }}-
                    {{
                      item.raw.description
                        ? getPosition(item.raw.description.positionCode)
                        : ""
                    }}
                  </template>
                </v-select>
                <v-alert
                  v-if="infoCarCodes && infoCarCodes.length > 1"
                  variant="tonal"
                  type="warning"
                  borer="bottom"
                >
                  {{ $t("select_position") }}
                </v-alert>
              </v-col>
              <!-----------------------------------CUSTOM TITLE------------------------------------>
              <v-col v-if="setCustomTitle === true" cols="12">
                <v-autocomplete
                  v-model="customInfoCarTitle"
                  v-model:search="searchInfoCarTitle"
                  :loading="loadingCustomInfoCarTitle"
                  :items="infoCarTitles"
                  :label="$t('parts.inventory.form.custom_info_car_title')"
                  :filter="() => true"
                  :item-title="`title.${$store.getters.language}`"
                  item-value="partCode"
                  color="red-darken-1"
                  return-object
                  :append-icon="
                    customInfoCarTitle === null
                      ? 'mdi-magnify'
                      : 'mdi-keyboard-backspace'
                  "
                  @click:append="customInfoCarTitle = null"
                />
                <v-select
                  v-model="customInfoCarPosition"
                  :items="customInfoCarPositionItems"
                  :label="$t('leko_employees.approve_parts.form.part_position')"
                  :hint="$t('leko_employees.approve_parts.form.part_position_hint')"
                  persistent-hint
                  color="red-darken-1"
                  class="custom-info-car-position mt-2"
                />
                <v-alert
                  v-if="role === 'InstitutionAdmin'"
                  type="info"
                  variant="tonal"
                  class="mt-3"
                >
                  {{ $t("global_settings.ebay_note") }}
                </v-alert>
              </v-col>
              <!--------------------------------------CAMERA--------------------------------------->
              <v-col v-if="changePhoto === true" cols="12">
                <camera v-if="dialog" @take-picture="takePicture" />
              </v-col>
              <!-- change part position  -->
              <v-col v-if="changePosition === true" cols="12">
                <v-row class="d-flex">
                  <v-col cols="12" lg="4" md="4">
                    <v-text-field
                      v-if="part.infoCar && part.infoCar.oemCode"
                      v-model="part.infoCar.oemCode"
                      :label="$t('parts.table.oem_code')"
                      color="red-darken-1"
                      variant="outlined"
                      disabled
                    />
                  </v-col>
                  <v-col cols="12" lg="8" md="8">
                    <v-btn
                      variant="flat"
                      color="success"
                      class="ma-1"
                      :loading="loadingInfoCar"
                      @click="searchCodePosition()"
                    >
                      {{ $t("parts.inventory.search") }}
                      <v-icon end>mdi-magnify</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-alert
                  v-model="alert.value"
                  :type="alert.type"
                  variant="outlined"
                  class="mt-3"
                >
                  {{ $t(alert.message) }}
                </v-alert>
                <v-col v-if="startSearchCode" cols="12" class="d-block">
                  <v-select
                    v-model="selectedInfoCar"
                    :items="infoCarResult"
                    :disabled="!foundCode"
                    item-value="_id"
                    :filter="() => true"
                    :item-title="`description.descriptionId.title.${$store.getters.language}`"
                    :label="
                      $t('leko_employees.approve_parts.form.info_car_result')
                    "
                    color="red-darken-1"
                    return-object
                  >
                    <template #item="{ props, item }">
                      <v-list-item v-bind="props">
                        <v-list-item-title>
                          {{ item.raw.oemCode }} -
                          {{
                            item.raw.description.descriptionId
                              ? item.raw.description.descriptionId.category.it
                              : ""
                          }}
                          :
                          {{
                            item.raw.description.descriptionId
                              ? item.raw.description.descriptionId.title.it
                              : ""
                          }}
                          -
                          {{
                            item.raw.description
                              ? getPosition(item.raw.description.positionCode)
                              : ""
                          }}
                        </v-list-item-title>
                      </v-list-item>
                    </template>

                    <template #selection="{ item }">
                      {{ item.raw.oemCode }} -
                      {{
                        item.raw.description.descriptionId
                          ? item.raw.description.descriptionId.category.it
                          : ""
                      }}
                      :
                      {{
                        item.raw.description.descriptionId
                          ? item.raw.description.descriptionId.title.it
                          : ""
                      }}-
                      {{
                        item.raw.description
                          ? getPosition(item.raw.description.positionCode)
                          : ""
                      }}
                    </template>
                  </v-select>
                  <v-alert
                    v-if="infoCarResult && infoCarResult.length > 1"
                    variant="tonal"
                    type="warning"
                    borer="bottom"
                  >
                    {{ $t("select_position") }}
                  </v-alert>
                </v-col>
              </v-col>
              <!------------------------------------PHOTO GRID------------------------------------->
              <v-col cols="12" class="min-width-0">
                <v-container grid-list-sm fluid>
                  <!--NEW PHOTOS-->
                  <v-row
                    class="d-flex flex-nowrap edit-dialog-photo-strip"
                    no-gutters
                  >
                    <div
                      v-for="(data, index) in tempImages"
                      :key="index"
                      class="shrink edit-dialog-photo-tile-wrap"
                    >
                      <v-card
                        flat
                        tile
                        draggable="true"
                        :data-index="index"
                        @dragstart="dragStartHandler"
                        @dragover.prevent
                        @drop="dropHandler"
                        @dragend="dragEndHandler"
                        @mouseenter="hoverIndex = index"
                        @mouseleave="hoverIndex = null"
                      >
                        <v-img :src="data.dataUrl" width="150px" class="mx-1">
                          <v-row
                            v-if="hoverIndex === index"
                            class="ma-1 d-flex justify-space-between"
                          >
                            <v-icon
                              size="x-large"
                              color="primary"
                              class="pointer"
                              @click="viewImage('dataUrl', data.dataUrl)"
                            >
                              mdi-image
                            </v-icon>

                            <v-icon
                              size="x-large"
                              color="orange"
                              class="pointer"
                              @click="openImageEditor('dataUrl', index, data)"
                            >
                              mdi-pencil
                            </v-icon>

                            <v-icon
                              v-if="data.originalDataUrl"
                              size="x-large"
                              color="orange-darken-2"
                              class="pointer"
                              @click="restoreTempOriginal(index)"
                            >
                              mdi-backup-restore
                            </v-icon>

                            <v-icon
                              size="x-large"
                              color="red"
                              class="pointer"
                              @click="deleteTempImage(index)"
                            >
                              mdi-delete-forever
                            </v-icon>
                          </v-row>
                        </v-img>
                      </v-card>
                    </div>
                  </v-row>
                  <!--EXISTING PHOTOS-->
                  <v-row
                    class="d-flex flex-nowrap edit-dialog-photo-strip"
                    no-gutters
                  >
                    <div
                      v-for="(image, index) in part.images"
                      :key="image.image"
                      class="shrink edit-dialog-photo-tile-wrap"
                    >
                      <v-card
                        flat
                        tile
                        draggable="true"
                        :data-index="index"
                        @dragstart="dragStartHandler"
                        @dragover.prevent
                        @drop="dropHandler"
                        @dragend="dragEndHandler"
                        @mouseenter="hoverIndex = index"
                        @mouseleave="hoverIndex = null"
                      >
                        <v-img
                          :src="`https://leko-tech.fra1.cdn.digitaloceanspaces.com/${image.thumb}`"
                          width="150px"
                          class="mx-1"
                        >
                          <v-row
                            v-if="hoverIndex === index"
                            class="ma-1 d-flex justify-space-between"
                          >
                            <v-icon
                              size="x-large"
                              color="primary"
                              class="pointer"
                              @click="viewImage('string', image)"
                            >
                              mdi-image
                            </v-icon>

                            <v-icon
                              size="x-large"
                              color="orange"
                              class="pointer"
                              @click="openImageEditor('string', index, image)"
                            >
                              mdi-pencil
                            </v-icon>

                            <v-icon
                              v-if="image.originalUrl"
                              size="x-large"
                              color="orange-darken-2"
                              class="pointer"
                              @click="restoreOriginalImage(index)"
                            >
                              mdi-backup-restore
                            </v-icon>

                            <v-icon
                              size="x-large"
                              color="red"
                              class="pointer"
                              @click="deleteImage(part._id, image, index)"
                            >
                              mdi-delete-forever
                            </v-icon>
                          </v-row>
                        </v-img>
                      </v-card>
                    </div>
                  </v-row>
                  <v-row>
                    <h2 class="mt-4">
                      {{ $t("parts.inventory.form.label_image") }}
                    </h2>
                  </v-row>
                  <v-row class="pa-2">
                    <v-card
                      v-if="image.src"
                      flat
                      tile
                      draggable="true"
                      :data-index="index"
                      @mouseenter="hoverIndex = index"
                      @mouseleave="hoverIndex = null"
                    >
                      <v-img
                        v-if="image.src"
                        :src="image.src"
                        width="150px"
                        class="mx-1"
                      >
                        <v-row
                          v-if="hoverIndex === index"
                          class="ma-1 d-flex justify-space-between"
                        >
                          <v-icon
                            size="x-large"
                            color="primary"
                            class="pointer"
                            @click="viewImage('dataUrl', image.src)"
                          >
                            mdi-image
                          </v-icon>

                          <!-- <v-icon
                            size="x-large"
                            color="orange"
                            class="pointer"
                            @click="openImageEditor('string', index, image)"
                          >
                            mdi-pencil
                          </v-icon> -->

                          <v-icon
                            size="x-large"
                            color="red"
                            class="pointer"
                            @click="deleteImageTemp(image)"
                          >
                            mdi-delete-forever
                          </v-icon>
                        </v-row>
                      </v-img>
                    </v-card>
                    <v-card
                      v-else-if="part.oemLableDetails"
                      flat
                      tile
                      draggable="true"
                      :data-index="index"
                      @dragstart="dragStartHandler"
                      @dragover.prevent
                      @drop="dropHandler"
                      @dragend="dragEndHandler"
                      @mouseenter="hoverIndex = index"
                      @mouseleave="hoverIndex = null"
                    >
                      <v-img
                        v-if="part.oemLableDetails"
                        :src="`https://leko-tech.fra1.cdn.digitaloceanspaces.com/${part.oemLableDetails}`"
                        width="150px"
                        class="mx-1"
                      >
                        <v-row
                          v-if="hoverIndex === index"
                          class="ma-1 d-flex justify-space-between"
                        >
                          <v-icon
                            size="x-large"
                            color="primary"
                            class="pointer"
                            @click="viewImage('label', part.oemLableDetails)"
                          >
                            mdi-image
                          </v-icon>

                          <!-- <v-icon
                            size="x-large"
                            color="orange"
                            class="pointer"
                            @click="
                              openImageEditor(
                                'string',
                                index,
                                part.oemLableDetails,
                              )
                            "
                          >
                            mdi-pencil
                          </v-icon> -->

                          <v-icon
                            size="x-large"
                            color="red"
                            class="pointer"
                            @click="
                              deleteImageTemp(part._id, part.oemLableDetails)
                            "
                          >
                            mdi-delete-forever
                          </v-icon>
                        </v-row>
                      </v-img>
                    </v-card>

                    <input
                      ref="fileInput"
                      type="file"
                      accept="image/*"
                      class="pt-6 mx-2"
                      @change="handleFileUpload"
                    />
                    <v-form class="mt-2">
                     <v-row v-if="loadingClassify" align="center" justify="center">
            <v-progress-circular indeterminate size="50" color="red-darken-2" />
          </v-row>
                    </br>
                      <span v-if="dataFound" class="ml-2 pt-2 text-red">{{
                        $t("parts.inventory.form.check_found_brand")
                      }}</span>
                    </v-form>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red-darken-1" variant="outlined" @click="close">
          {{ $t("parts.inventory.form.close") }}
        </v-btn>
        <v-btn
          :disabled="!valid || (changeInfoCarCode && !validInfoCarCode)"
          :loading="loading"
          color="green-darken-1"
          variant="outlined"
          @click="save"
        >
          {{ $t("parts.inventory.form.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import Camera from "../camera.vue";
import getRequest from "../../api/getRequest";
import postRequest from "../../api/postRequest";
import { dataURLtoBlob } from "../../utils/files";
import ExportMarketplaces from "@/components/common/ExportMarketplaces.vue";
import EcoScoreBadge from "@/components/common/EcoScoreBadge.vue";
import { ecoScoreFor } from "@/utils/ecoScoreLookup";

export default {
  components: {
    camera: Camera,
    "export-marketplaces": ExportMarketplaces,
    "eco-score-badge": EcoScoreBadge,
  },
  props: ["hide"], // eslint-disable-line vue/require-prop-types
  data: () => ({
    draggingIndex: -1,
    dropIndex: -1,
    valid: false,
    dialog: false,
    changePhoto: false,
    changeInfoCarCode: false,
    setCustomTitle: false,
    partWasRefused: false,
    validInfoCarCode: false,
    customInfoCarTitle: null,
    customInfoCarPosition: "S000",
    searchInfoCarTitle: null,
    infoCarTitles: [],
    loading: false,
    loadingInfoCar: false,
    loadingCustomInfoCarTitle: false,
    tempImages: [],
    part: {},
    client: {},
    clients: [],
    currency: ["EUR"], // 'ALL'
    weight: { value: 0, unit: "kg" },
    weightUnits: ["kg"],
    infoCarCode: null,
    tests: [],
    warranties: [],
    shipments: [],
    qualities: [],
    repositories: [],
    repository: {},
    room: {},
    location: {},
    loadingRepositoryLocation: false,
    pos_x: [],
    pos_y: [],
    position_x: null,
    position_y: null,
    shippingCosts: {
      ebay: {
        it: null,
        de: "",
        fr: "",
        es: "",
      },
      google: {
        it: "",
        de: "",
        fr: "",
        es: "",
      },
      rr: "",
    },
    defaultCountries: ["it", "de", "fr", "es"],
    weightRanges: [{ value: null, label: "Default" }],
    allowedWeightRanges: [],
    loadingWeightRanges: false,
    originalPart: null,
    oldShippings: null,
    externalColor: "",
    hoverIndex: null,
    image: {
      type: null,
      src: null,
      url: null,
    },
    imageValid: false,
    rotation: 0,
    img: null,
    loadingClassify: false,
    dataFound: false,
    alerts: {
      status: true,
      mismatches: [
        {
          field: "position", // e.g., "position", "title", "compatibility"
          reason: "Position mismatch with position in notes", // e.g., "Position mismatch with position in notes"
          // type: { type: String, enum: ['info','warning','error'], default: 'warning' },
          type: "warning",
          createdAt: "",
        },
        {
          field: "title", // e.g., "position", "title", "compatibility"
          reason: "Wrong title", // e.g., "Position mismatch with position in notes"
          type: "error",
          createdAt: "",
        },
      ],
    },
    positionAlerts: [],
    changePosition: false,
    canChangePosition: false,
    infoCarResult: [],
    selectedInfoCar: null,
    foundCode: false,
    alert: {
      value: false,
      message: "",
      type: "error",
    },
    willChangePosition: false,
    startSearchCode: false,
    newInfoCarCode: null,
    infoCarCodes: [],
  }),
  computed: {
    partEcoScore() {
      return ecoScoreFor(this.part);
    },
    selectedQualityRating() {
      if (!this.part.quality) return 0;
      if (typeof this.part.quality === "object") {
        return this.part.quality.rating ?? this.part.quality.value ?? 0;
      }
      const q = this.qualities.find((q) => q._id === this.part.quality);
      return q ? (q.rating ?? q.value ?? 0) : 0;
    },
    qualityRatingSize() {
      return this.$vuetify.display.smAndDown ? "small" : "default";
    },
    exportMarketplaceColSize() {
      if (!this.$vuetify.display.smAndDown) {
        return 12;
      }
      const showEbay = this.$store.getters.institutionExportEbayLeko;
      const showRr = this.showRrExport;
      return showEbay && showRr ? 6 : 12;
    },
    showRrExport() {
      return (
        this.$store.getters.institutionRr === true ||
        this.part?.institution_id?.rr === true
      );
    },
    server() {
      return this.$serverUri;
    },
    role() {
      return this.$store.getters.role;
    },
    hideDialog() {
      return this.$props.hide;
    },
    editId() {
      if (this.part.old_id && this.part.old_id !== undefined) {
        const id = this.part.old_id;
        return id.slice(id.length - 6, id.length);
      } else if (this.part._id && this.part._id !== undefined) {
        const id = this.part._id;
        return id.slice(id.length - 6, id.length);
      }
      return null;
    },
    canSetCustomTitle() {
      if (
        this.role === "LekoAdmin" ||
        this.role === "LekoEmployee" ||
        this.role === "SuperAdmin"
      ) {
        return true;
      }
      if (this.role !== "InstitutionAdmin") return false;
      if (!this.$store.getters.refusedCatalogTitleEnabled) return false;
      const source = this.originalPart || this.part;
      if (!source) return false;
      return this.partWasRefused && this.isMissingCatalog(source);
    },
    hasCustomInfoCarTitle() {
      const infoCar = this.part && this.part.infoCar;
      return !!(
        infoCar &&
        infoCar.description &&
        infoCar.description.descriptionId &&
        !infoCar._id
      );
    },
    customInfoCarPositionItems() {
      return [
        {
          title:
            this.$t("neutral").charAt(0).toUpperCase() +
            this.$t("neutral").slice(1),
          value: "S000",
        },
        { title: "SX", value: "S001" },
        { title: "DX", value: "S002" },
      ];
    },
  },
  watch: {
    hideDialog(value) {
      if (value) {
        this.dialog = false;
      } else {
        this.dialog = true;
      }
    },
    dialog(value) {
      if (value) {
        this.getClients();
        this.getWarranties();
        this.getRepositories();
        this.getShipments();
        this.getQualities();
      }
    },
    repository(newVal, oldVal) {
      if (this.loadingRepositoryLocation) return;
      if (oldVal && oldVal._id && newVal._id !== oldVal._id) {
        this.room = null;
        this.location = null;
        this.position_x = null;
        this.position_y = null;
        this.pos_x = [];
      }
    },
    room(newVal, oldVal) {
      if (this.loadingRepositoryLocation) return;
      if (oldVal && oldVal._id && newVal && newVal._id !== oldVal._id) {
        this.location = null;
        this.position_x = null;
        this.position_y = null;
        this.pos_x = [];
      }
    },
    location(value) {
      if (value && value.position_x !== undefined) {
        this.generateCoordinates(value.position_x, value.position_y);
      }
    },
    changeInfoCarCode(value) {
      if (!value) {
        this.validInfoCarCode = false;
        this.infoCarCode = null;
      }
    },
    searchInfoCarTitle(value) {
      if (value) {
        this.loadingCustomInfoCarTitle = true;
        getRequest(
          "/info-car/parts",
          `title=${value}&language=${this.$store.getters.language}&all=true`,
        )
          .then((response) => {
            this.infoCarTitles = response.parts;
          })
          .catch(() => {})
          .finally(() => {
            this.loadingCustomInfoCarTitle = false;
          });
      }
    },
    customInfoCarTitle(value) {
      if (value) {
        this.applyCustomInfoCarStub();
      } else {
        delete this.part.infoCar;
      }
    },
    customInfoCarPosition() {
      if (!this.setCustomTitle) {
        return;
      }
      this.applyCustomInfoCarStub();
    },
    setCustomTitle(value) {
      if (!value) {
        return;
      }
      const code = this.part?.infoCar?.description?.positionCode;
      this.customInfoCarPosition =
        code === "S001" || code === "S002" || code === "S000" ? code : "S000";
    },
  },
  methods: {
    keepPriceIfValid(value, current) {
      if (value === "" || value == null) return value;
      const n = Number(value);
      if (!Number.isFinite(n) || n > 10000) return current;
      return value;
    },
    isMissingCatalog(source) {
      const oem = source?.infoCar?.oemCode;
      if (oem && String(oem).trim()) return false;
      const descriptionId = source?.infoCar?.description?.descriptionId;
      if (descriptionId == null || descriptionId === "") return true;
      if (Array.isArray(descriptionId) && descriptionId.length === 0) return true;
      if (typeof descriptionId === "object") {
        const title = descriptionId.title;
        const text =
          (title && (title.it || title.en || title.sq || title.de || title.fr || title.es)) ||
          "";
        return !String(text).trim();
      }
      return false;
    },
    isRefusedUntitledSource(source, historyItems = []) {
      if (source?.refusal_reason && String(source.refusal_reason).trim()) {
        return true;
      }
      const fromPart = source?.movement_history || [];
      const combined = fromPart.concat(historyItems);
      return combined.some((movement) => Number(movement.status) === 1.3);
    },
    async refreshRefusedCatalogTitleFlag() {
      if (this.role !== "InstitutionAdmin") return;
      try {
        const res = await getRequest("/global-settings/refused-catalog-title");
        this.$store.commit(
          "set_refused_catalog_title",
          !!(res && res.enabled),
        );
      } catch (err) {
        /* keep the flag from login */
      }
    },
    async fetchRefuseHistory(part) {
      if (!part || !part._id) return [];
      try {
        const query = [];
        if (part.old_id) query.push(`old_id=${part.old_id}`);
        if (part.backup_id) query.push(`backup_id=${part.backup_id}`);
        const response = await getRequest(
          `/history/part/single/${part._id}`,
          query.join("&"),
        );
        if (Array.isArray(response)) return response;
        if (Array.isArray(response?.history)) return response.history;
        return [];
      } catch (err) {
        return [];
      }
    },
    onEditQualitySelect(val) {
      if (val === 0 || this.selectedQualityRating === val) {
        this.part.quality = null;
      } else {
        const match = this.qualities.find(
          (q) => q.rating === val || q.value === val,
        );
        this.part.quality = match ? match._id : null;
      }
    },
    async open(data) {
      await this.refreshRefusedCatalogTitleFlag();
      const historyItems = await this.fetchRefuseHistory(data);
      this.partWasRefused = this.isRefusedUntitledSource(data, historyItems);
      this.loadingRepositoryLocation = true;
      this.repository = {};
      this.room = {};
      this.location = {};
      this.position_x = null;
      this.position_y = null;
      this.pos_x = [];
      this.pos_y = [];
      this.part = data;
      if (this.part.rrExport !== false) this.part.rrExport = true;
      if (this.part.exportEbay !== false) this.part.exportEbay = true;
      this.externalColor =
        data.car && data.car.externalColor ? data.car.externalColor : "";
      this.originalPart = JSON.parse(JSON.stringify(data));
      this.oldShippings = data.shippingCosts;
      this.shippingCosts = {
        ebay: {
          ...((this.shippingCosts && this.shippingCosts.ebay) || {}),
          ...((data.shippingCosts && data.shippingCosts.ebay) || {}),
        },
        google: {
          ...((this.shippingCosts && this.shippingCosts.google) || {}),
          ...((data.shippingCosts && data.shippingCosts.google) || {}),
        },
        rr:
          data.shippingCosts?.rr !== undefined
            ? data.shippingCosts.rr
            : this.shippingCosts?.rr || "",
      };
      if (data.weight) this.weight = data.weight;
      this.getRepository(data.repository_id);
      if (this.$store.getters.institutionExportEbayLeko) {
        this.fetchWeightRanges();
      }

      this.image = {
        type: null,
        src: null,
        url: null,
      };
      this.img = null;
      this.dataFound = false;
      if (
        data.alerts &&
        data.alerts.status == true &&
        data.alerts.mismatches &&
        data.alerts.mismatches.length > 0
      ) {
        this.positionAlerts = data.alerts.mismatches.filter(
          (a) => a?.field === "position",
        );
      }
      if (
        data &&
        data.infoCar &&
        data.infoCar.description &&
        data.infoCar.description.positionCode &&
        (data.infoCar.description.positionCode == "S001" ||
          data.infoCar.description.positionCode == "S002")
      ) {
        this.canChangePosition = true;
      }
      this.dialog = true;
    },
    applyCustomInfoCarStub() {
      const positionCode = this.customInfoCarPosition || "S000";
      if (this.customInfoCarTitle) {
        this.part.infoCar = {
          description: {
            descriptionCode: this.customInfoCarTitle.partCode,
            positionCode,
            descriptionId: this.customInfoCarTitle._id,
          },
        };
        return;
      }
      if (this.hasCustomInfoCarTitle) {
        this.part.infoCar = {
          ...this.part.infoCar,
          description: {
            ...this.part.infoCar.description,
            positionCode,
          },
        };
      }
    },
    close() {
      this.part = {};
      this.clients = [];
      this.warranties = [];
      this.repositories = [];
      this.qualities = [];
      this.tempImages = [];
      this.weight = { value: 0, unit: "kg" };
      this.changePhoto = false;
      this.changeInfoCarCode = false;
      this.infoCarCode = null;
      this.setCustomTitle = false;
      this.partWasRefused = false;
      this.customInfoCarTitle = null;
      this.customInfoCarPosition = "S000";
      this.searchInfoCarTitle = null;
      this.infoCarTitles = [];
      this.dialog = false;
      this.img = null;
      this.image = {
        type: null,
        src: null,
        url: null,
      };
      this.dataFound = false;
      this.loading = false;
      this.externalColor = "";
      this.shippingCosts = {
        ebay: {
          it: "",
          de: "",
          fr: "",
          es: "",
        },
        google: {
          it: "",
          de: "",
          fr: "",
          es: "",
        },
        rr: "",
      };
      this.repository = {};
      this.room = {};
      this.location = {};
      this.position_x = null;
      this.position_y = null;
      this.pos_x = [];
      this.pos_y = [];
      this.loadingRepositoryLocation = false;
      this.canChangePosition = false;
      this.changePosition = false;
      this.startSearchCode = false;
      this.selectedInfoCar = null;
      this.infoCarResult = [];
      this.willChangePosition = false;
      this.newInfoCarCode = null;
      this.infoCarCodes = [];
      this.$emit("close");
    },
    normalizeImages(images = []) {
      return images
        .map((img) => ({
          first: !!img.first,
          image: img.image || "",
          thumb: img.thumb || "",
          originalUrl: img.originalUrl || "",
          originalThumb: img.originalThumb || "",
        }))
        .sort((a, b) => (a.image + a.thumb).localeCompare(b.image + b.thumb)); // ensures consistent order
    },
    async save() {
      //  this.part.shippingCosts = {
      // ebay: Object.fromEntries(Object.entries(this.shippingCosts.ebay).filter(([key, value]) => value !== '')),
      //  google: Object.fromEntries(Object.entries(this.shippingCosts.google).filter(([key, value]) => value !== '')),
      //  };
      this.part.shippingCosts = {
        ebay: Object.fromEntries(
          Object.entries(this.shippingCosts.ebay).filter(
            ([key, value]) => value !== "" && value != null,
          ),
        ),
        google: Object.fromEntries(
          Object.entries(this.shippingCosts.google).filter(
            ([key, value]) => value !== "" && value != null,
          ),
        ),
        rr: this.shippingCosts.rr,
      };

      if (this.part && this.part.eBayStatus) {
        const fieldsToCompare = [
          "price",
          "cost",
          "notes",
          "ebayCode",
          "isNewPart",
          "manufacturer_code",
          "weightRange",
        ];
        const hasChanged = fieldsToCompare.some(
          (field) => this.part[field] !== this.originalPart[field],
        );
        // const shippingChanged = JSON.stringify(this.part.shippingCosts.ebay) !== JSON.stringify(this.oldShippings.ebay);
        const shippingChanged =
          JSON.stringify(this.part.shippingCosts) !==
          JSON.stringify(this.oldShippings || {});

        const imagesChanged =
          JSON.stringify(this.normalizeImages(this.part.images)) !==
          JSON.stringify(this.normalizeImages(this.originalPart.images));
        const newImagesAdded = this.tempImages && this.tempImages.length > 0;

        const finalHasChangedFlag =
          hasChanged || shippingChanged || imagesChanged || newImagesAdded;
        if (finalHasChangedFlag) {
          this.part.ebayChanges = true;
        }
      }
      if (this.externalColor) {
        this.part.car.externalColor = this.externalColor;
      }
      this.loading = true;
      // REPOSITORY ID's
      if (this.repository._id) {
        this.part.repository_id = this.repository._id;
        if (this.room._id) {
          this.part.room_id = this.room._id;
          if (this.location._id) {
            this.part.location_id = this.location._id;
            if (this.position_x && this.position_y) {
              this.getShelfId(this.position_x, this.position_y, (callback) => {
                this.part.shelf_id = callback;
              });
            }
          }
        }
      }
      this.part.weight = this.weight;
      if (this.part.quality && typeof this.part.quality === "object") {
        this.part.quality = this.part.quality._id;
      }
      // FORMDATA
      const formData = new FormData();
      // APPEND DATA
      formData.append(
        "data",
        JSON.stringify({
          part: this.part,
          infoCar: {
            code:
              this.newInfoCarCode && this.newInfoCarCode.oemCode
                ? this.newInfoCarCode.oemCode
                : this.infoCarCode,
            newInfoCar:
              this.newInfoCarCode && this.newInfoCarCode._id
                ? this.newInfoCarCode._id
                : null,
            changeInfoCarCode: !!(
              (this.infoCarCode ||
                (this.newInfoCarCode && this.newInfoCarCode.oemCode)) &&
              this.changeInfoCarCode
            ),
          },
          // change part position
          changePosition: {
            newInfoCar: this.selectedInfoCar ? this.selectedInfoCar._id : null,
            status: this.willChangePosition,
          },
          replacedImageOriginals: this.collectReplacedImageOriginals(),
        }),
      );

      // APPEND PHOTOS
      if (this.tempImages.length > 0) {
        this.tempImages.forEach((image) => {
          formData.append("photos", image.blob, image.title);
        });
      }
      if (this.img) {
        formData.append("oemLableDetails", this.img, "oemLabel.png");
      }
      try {
        // POST request with formData
        const response = await postRequest.formData(
          "/part/edit/",
          `id=${this.part._id}`,
          formData,
        );
        // response is { part, ebayError }
        if (
          response &&
          response.data &&
          response.data.ebayError &&
          response.data.ebayError != null
        ) {
          this.$emit("show-error-modal", response.data.ebayError);
        } else if (response && response.data && response.data.ebayRelisted) {
          this.$emit(
            "show-error-modal",
            this.$t("parts.inventory.id_changer.ebay_relist_message"),
          );
        }
        // Close modal or do something else after success
        this.close();
      } catch (error) {
        this.close();
        this.$emit("show-error-modal", error.response.data);
        
      } finally {
        this.loading = false;
      }
    },
    getClients() {
      getRequest(
        "/client/",
        `role=${this.$store.getters.role}&institution_id=${
          this.$store.getters.institutionId
        }`,
      )
        .then((response) => {
          this.clients = response.clients;
        })
        .catch(() => {});
    },
    fetchWeightRanges() {
      this.loadingWeightRanges = true;
      getRequest("/institution/weight-ranges")
        .then((response) => {
          const allowed = response.allowedWeightRanges || [];
          this.allowedWeightRanges = allowed;
          this.weightRanges = [
            { value: null, label: "Default" },
            ...allowed.map((r) => ({ value: r, label: `${r} kg` })),
          ];
        })
        .catch(() => {})
        .finally(() => {
          this.loadingWeightRanges = false;
        });
    },
    getWarranties() {
      getRequest("/warranty/")
        .then((response) => {
          this.warranties = response.warranties;
        })
        .catch(() => {});
    },
    getShipments() {
      getRequest(
        "/shipment/",
        `role=${
          this.$store.getters.role
        }&institution_id=${this.$store.getters.institutionId}`,
      )
        .then((response) => {
          this.shipments = response.shipments;
        })
        .catch(() => {});
    },
    applyShelfPosition(location) {
      const shelf = location?.shelves?.find(
        (s) => s._id === this.part.shelf_id,
      );
      if (shelf) {
        this.position_x = shelf.x;
        this.position_y = shelf.y;
      } else if (this.part.shelf_data?.shelf) {
        this.position_x = this.part.shelf_data.shelf.x ?? null;
        this.position_y = this.part.shelf_data.shelf.y ?? null;
      }
      if (location?.position_x !== undefined) {
        this.generateCoordinates(location.position_x, location.position_y);
      }
    },
    applyRepositoryLocation(repository) {
      if (!repository?._id) return;
      this.repository = repository;
      const room = repository.rooms?.find((r) => r._id === this.part.room_id);
      if (!room) {
        this.room = {};
        this.location = {};
        return;
      }
      this.room = room;
      const location = room.locations?.find(
        (l) => l._id === this.part.location_id,
      );
      if (!location) {
        this.location = {};
        return;
      }
      this.location = location;
      this.applyShelfPosition(location);
    },
    syncRepositoryWithList() {
      if (!this.repository?._id || !this.repositories?.length) return;
      const index = this.repositories.findIndex(
        (r) => r._id === this.repository._id,
      );
      if (index < 0) return;
      const listRepo = this.repositories[index];
      if (this.repository.rooms?.length && !listRepo.rooms?.length) {
        this.repositories[index] = { ...listRepo, rooms: this.repository.rooms };
      }
      const matched = this.repositories[index];
      this.loadingRepositoryLocation = true;
      this.applyRepositoryLocation(matched);
      this.loadingRepositoryLocation = false;
    },
    getRepository(id) {
      if (!id) {
        this.loadingRepositoryLocation = false;
        return;
      }
      getRequest("/repository", `id=${id}`)
        .then((response) => {
          const fullRepo = response.repository?.[0];
          if (!fullRepo) return;
          this.loadingRepositoryLocation = true;
          this.applyRepositoryLocation(fullRepo);
          this.syncRepositoryWithList();
        })
        .catch(() => {})
        .finally(() => {
          this.loadingRepositoryLocation = false;
        });
    },
    getRepositories() {
      getRequest(
        "/repository/",
        `role=${this.$store.getters.role}&institution_id=${
          this.$store.getters.institutionId
        }`,
      )
        .then((response) => {
          this.repositories = response.repositories;
          this.syncRepositoryWithList();
        })
        .catch(() => {});
    },
    getQualities() {
      getRequest("/quality/")
        .then((response) => {
          this.qualities = response.qualities;
        })
        .catch(() => {});
    },
    generateCoordinates(x, y) {
      const xArr = [];
      const yArr = [];
      for (let _x = 1; _x <= x; _x += 1) {
        xArr.push(_x);
      }
      for (let _y = 1; _y <= y; _y += 1) {
        yArr.push(_y);
      }
      this.pos_x = xArr;
      this.pos_y = yArr;
      this.scannerPos_x = xArr;
      this.scannerPos_y = yArr;
    },
    getShelfId(x, y, cb) {
      if (this.location.shelves && this.location.shelves.length > 0) {
        this.location.shelves.forEach((shelf) => {
          if (shelf.x === x && shelf.y === y) {
            cb(shelf._id);
          }
        });
      } else {
        cb("");
      }
    },
    openIdChanger() {
      this.$emit("open-id-changer");
    },
    openIdSwitcher() {
      this.$emit("open-id-switcher");
    },
    changeId(id) {
      this.part.backup_id = this.part.old_id;
      this.part.old_id = id;
    },
    viewImage(type, data) {
      this.$emit("open-img-dialog", { type, data });
    },
    openImageEditor(type, index, data) {
      this.$emit("open-img-editor", { type, index, data });
    },
    setEditedImage(image) {
      if (image.restoreOriginal) {
        if (image.type === "dataUrl") {
          this.restoreTempOriginal(image.index, image);
          return;
        }
        this.restoreOriginalImage(image.index, image);
        return;
      }
      let type = "";
      // Remove the existing unedited image.
      if (image.type === "dataUrl") {
        type = "n";
        this.deleteTempImage(image.index);
      }
      if (image.type === "string") {
        type = "e";
        this.deleteImage(null, null, image.index);
      }
      // Add the edited one.
      this.tempImages.push({
        title: `${type}-${image.index}-${image.title}`,
        dataUrl: image.dataUrl,
        blob: image.blob,
        originalUrl: image.originalUrl || null,
        originalThumb: image.originalThumb || null,
        originalDataUrl: image.originalDataUrl || null,
        originalBlob: image.originalBlob || null,
      });
    },
    collectReplacedImageOriginals() {
      const originals = {};
      this.tempImages.forEach((image) => {
        if (!image.originalUrl) return;
        const parts = (image.title || "").split("-");
        if (parts[0] === "e" && parts[1] !== undefined) {
          originals[parts[1]] = {
            originalUrl: image.originalUrl,
            originalThumb: image.originalThumb || null,
          };
        }
      });
      return originals;
    },
    restoreOriginalImage(index, payload = null) {
      const image = this.part.images[index];
      const originalUrl = (payload && payload.originalUrl) || (image && image.originalUrl);
      if (!image || !originalUrl) return;
      this.part.images.splice(index, 1, {
        ...image,
        image: originalUrl,
        thumb:
          (payload && payload.originalThumb) ||
          image.originalThumb ||
          originalUrl,
        originalUrl: null,
        originalThumb: null,
      });
    },
    restoreTempOriginal(index, payload = null) {
      const image = this.tempImages[index];
      const originalDataUrl =
        (payload && payload.originalDataUrl) ||
        (image && image.originalDataUrl);
      if (!image || !originalDataUrl) return;
      this.tempImages.splice(index, 1, {
        ...image,
        dataUrl: originalDataUrl,
        blob: (payload && payload.originalBlob) || image.originalBlob,
        originalUrl: null,
        originalThumb: null,
        originalDataUrl: null,
        originalBlob: null,
      });
    },
    takePicture(data) {
      const randomString = Math.random().toString(36).substring(9);
      const imgObj = {
        title: `${randomString}-photo${this.tempImages.length}.png`,
        dataUrl: data.dataUrl,
        blob: data.blob,
      };
      this.tempImages.push(imgObj);
    },
    deleteImage(id, image, index) {
      this.part.images.splice(index, 1);
    },
    deleteImageTemp(image) {
      this.image = {
        type: null,
        src: null,
        url: null,
      };
      this.img = null;
      this.part.oemLableDetails = null;
    },
    deleteTempImage(index) {
      this.tempImages.splice(index, 1);
    },
    dragStartHandler(e) {
      this.draggingIndex = parseInt(
        e.currentTarget.getAttribute("data-index"),
        10,
      );
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/html", null);
    },
    dropHandler(e) {
      this.dropIndex = parseInt(e.currentTarget.getAttribute("data-index"), 10);
      if (this.draggingIndex !== this.dropIndex) {
        const draggedImage = this.part.images[this.draggingIndex];
        this.part.images.splice(this.draggingIndex, 1);
        this.part.images.splice(this.dropIndex, 0, draggedImage);
      }
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },
    dragEndHandler() {
      this.draggingIndex = -1;
      this.dropIndex = -1;
    },
    searchCode() {
      this.loadingInfoCar = true;
      getRequest("/info-car/search", `code=${this.infoCarCode}&populated=true`)
        .then((response) => {
          if (response) {
            this.infoCarCode = response[0].oemCode;
            this.newInfoCarCode = response[0];
            this.infoCarCodes = response;
            this.validInfoCarCode = true;
          }
          this.loadingInfoCar = false;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingInfoCar = false;
        });
    },
    async handleFileUpload() {
      // Get the file input element using the ref
      const { fileInput } = this.$refs;

      if (fileInput.files.length > 0) {
        const image = fileInput.files[0];
        this.img = image;
        const reader = new FileReader();
        reader.onload = (event) => {
          this.image = { type: "file", src: event.target.result, url: null };
          this.getImageDetails();
        };
        reader.readAsDataURL(image);
      }
    },
    getLinkedCarHints() {
      // Prefer `car` field; fall back to nested car_id if populated
      const car =
        this.part?.car ||
        (this.part?.car_id && typeof this.part.car_id === "object"
          ? this.part.car_id
          : null);
      if (!car) {
        return { brand: "", model: "", version: "", notes: "" };
      }
      const brand =
        typeof car.brand === "string"
          ? car.brand.trim()
          : (car.brand?.title || "").trim();
      const model =
        typeof car.model === "string"
          ? car.model.trim()
          : (
              car.model?.fullDescription ||
              car.model?.description ||
              ""
            ).trim();
      const version =
        typeof car.version === "string"
          ? car.version.trim()
          : (
              car.version?.fullDescription ||
              car.version?.description ||
              ""
            ).trim();
      return {
        brand,
        model,
        version,
        notes: (this.part?.notes || "").trim(),
      };
    },
    async getImageDetails() {
      if (!this.part.oemLableDetails && !this.image.src) {
        return;
      }
      this.loadingClassify = true;
      try {
        const { brand, model, version, notes } = this.getLinkedCarHints();
        let payload;
        const config = {};
        if (this.image.type === "file") {
          // Send file as FormData — do not set Content-Type (boundary must be set by axios)
          payload = new FormData();
          payload.append(
            "image",
            dataURLtoBlob(this.image.src),
            "uploaded-image.jpg",
          );
          if (brand) payload.append("brand", brand);
          if (model) payload.append("model", model);
          if (version) payload.append("version", version);
          if (notes) payload.append("notes", notes);
        } else {
          // Send URL as JSON; omit empty optional hints
          payload = {
            image: `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${this.part.oemLableDetails}`,
            ...(brand && { brand }),
            ...(model && { model }),
            ...(version && { version }),
            ...(notes && { notes }),
          };
        }
        const response = await axios.post(
          // 'https://oemlabeldetectionv4-97815853843.us-central1.run.app/get-image-detail', // gemini 1.5
          "https://new-extract-model-v2-97815853843.us-central1.run.app/get-image-detail", // gemini 2.5
          payload,
          config,
        );
        if (response && response.data && response.data.data) {
          const text = String(response.data.data).trim();
          if (
            !text ||
            /error|exception|server error|failed/i.test(text) ||
            /^\s*[\{\[]/.test(text)
          ) {
            this.loadingClassify = false;
            return;
          }
          this.dataFound = true;
          const lines = response.data.data.split("\n");

          let extractedBrand = "";
          let oem = "";
          lines.forEach((line, index) => {
            if (line.trim() === "Manufacturer:" && lines[index + 1]) {
              extractedBrand = lines[index + 1].trim();
            }
            if (line.trim() === "OEM Code:" && lines[index + 1]) {
              oem = lines[index + 1].trim();
              oem = oem.replace(/-/g, "").replace(/\s+/g, "");
            }
          });
          if (extractedBrand != null && extractedBrand !== "-") {
            this.part.brand = extractedBrand;
          }
          if (
            oem != null &&
            oem !== "" &&
            oem !== "-" &&
            this.part.extractedLabelOemCodeAI != oem
          ) {
            this.part.extractedLabelOemCodeAI = oem;
          }
        }
      } catch {
      } finally {
        this.loadingClassify = false;
      }
    },
    removeOemCode(index) {
      this.part.oemCodes.splice(index, 1);
    },
    getAlertIcon(type) {
      switch (type) {
        case "info":
          return "mdi-information";
        case "warning":
          return "mdi-alert-circle";
        case "error":
          return "mdi-close-octagon";
        default:
          return "";
      }
    },
    getAlertColor(type) {
      switch (type) {
        case "info":
          return "blue";
        case "warning":
          return "orange";
        case "error":
          return "red";
        default:
          return "";
      }
    },
    openChangePosition() {
      this.changePosition = true;
    },
    searchCodePosition() {
      // Search code.
      this.startSearchCode = true;
      this.selectedInfoCar = null;
      this.loadingInfoCar = true;
      getRequest(
        "/info-car/search/",
        `code=${this.part.infoCar.oemCode}&populated=true`,
      )
        .then((response) => {
          if (response) {
            this.loadingInfoCar = false;
            this.infoCarResult = response;
            [this.selectedInfoCar] = response;
            this.foundCode = true;
            this.willChangePosition = true;
          }
        })
        .catch((error) => {
          this.alert.type = "error";
          this.alert.message = error.response.data || error;
          this.alert.value = true;
          this.loadingInfoCar = false;
          this.infoCarResult = [];
          this.foundCode = false;
          setTimeout(() => {
            this.alert.value = false;
            this.alert.message = "";
          }, 3000);
        });
    },
    getPosition(code) {
      switch (code) {
        case "S001":
          return this.$t("left");
        case "S002":
          return this.$t("right");
        default:
          return "";
      }
    },
  },
};
</script>

<style scoped>
.min-width-0 {
  min-width: 0;
}

.custom-info-car-position :deep(.v-messages) {
  color: rgb(var(--v-theme-error));
  opacity: 1;
}

.shipping-cost-fields {
  gap: 8px;
}

.shipping-cost-field {
  flex: 1 1 88px;
  min-width: 88px;
  max-width: 140px;
}

/* Horizontal scroll when many thumbnails exceed dialog width (mobile + desktop) */
.edit-dialog-photo-strip {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding-bottom: 6px;
}

.edit-dialog-photo-strip .edit-dialog-photo-tile-wrap {
  flex-shrink: 0 !important;
}

@media (max-width: 959px) {
  .edit-dialog-photo-strip {
    -webkit-overflow-scrolling: touch;
    touch-action: pan-x;
  }

  .edit-dialog-part-meta {
    width: 100%;
  }

  .edit-dialog-quality-col {
    padding-bottom: 8px;
  }

  .edit-dialog-quality-rating {
    max-width: 100%;
  }

  .edit-dialog-quality-col .text-caption {
    margin-top: 2px !important;
  }

  /* Condizione: single compact row */
  .edit-dialog-part-meta > .edit-dialog-condition-col .part-export-field {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 48px;
    padding: 6px 12px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.02);
  }

  .edit-dialog-part-meta > .edit-dialog-condition-col .part-export-field__header {
    height: auto;
    font-size: 0.875rem;
    font-weight: 500;
  }

  .edit-dialog-part-meta > .edit-dialog-condition-col .part-export-field__checkbox {
    flex-shrink: 0;
  }

  /* eBay / RR: two columns when both visible; full width when only one */
  .edit-dialog-part-meta > .part-export-col:not(.edit-dialog-condition-col) {
    flex: 0 0 50%;
    max-width: 50%;
    padding-top: 8px;
  }

  .edit-dialog-part-meta
    > .part-export-col:not(.edit-dialog-condition-col).v-col-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .edit-dialog-part-meta
    > .part-export-col:not(.edit-dialog-condition-col)
    .part-export-field {
    width: 100%;
    min-height: 72px;
    padding: 8px 10px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.02);
    box-sizing: border-box;
  }

  .edit-dialog-part-meta
    > .part-export-col:not(.edit-dialog-condition-col)
    .part-export-field__header {
    margin-bottom: 2px;
  }

  .edit-dialog-part-meta
    > .part-export-col:not(.edit-dialog-condition-col)
    .part-export-field__checkbox
    :deep(.v-label) {
    font-size: 0.8125rem;
  }

  .edit-dialog-eco-col {
    padding-bottom: 4px;
  }

  .edit-dialog-actions-row {
    flex-direction: column;
    align-items: stretch !important;
    gap: 10px;
    width: 100%;
  }

  .edit-dialog-actions-row :deep(.edit-dialog-action-btn) {
    width: 100%;
    margin: 0 !important;
    white-space: normal;
    height: auto !important;
    min-height: 36px;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .edit-dialog-actions-row :deep(.edit-dialog-action-btn .v-btn__content) {
    white-space: normal;
    line-height: 1.3;
    text-align: center;
  }
}
</style>
